import { Icon, IconProps } from './Icon';

interface DiscoverIconProps extends IconProps {
  gradient?: {
    id: string;
    stops: { offset: string; color: string }[];
  };
}

export const DiscoverIcon = ({ gradient, ...props }: DiscoverIconProps) => {
  if (gradient) {
    return (
      <Icon
        {...props}
        viewBox="0 0 28 28"
      >
        <defs>
          <linearGradient
            id={gradient.id}
            x1="80%"
            y1="20%"
            x2="20%"
            y2="80%"
          >
            {gradient.stops.map((stop, index) => (
              <stop
                key={index}
                offset={stop.offset}
                stopColor={stop.color}
              />
            ))}
          </linearGradient>
        </defs>
        <rect
          x="1.82227"
          y="1.82227"
          width="24.6"
          height="24.6"
          rx="12.3"
          fill="#C2E2FF"
        />
        <rect
          x="1.82227"
          y="1.82227"
          width="24.6"
          height="24.6"
          rx="12.3"
          fill={`url(#${gradient.id})`}
        />
        <path
          d="M14.1224 9.11133C14.5918 11.6593 16.5855 13.653 19.1336 14.1224C16.5855 14.5918 14.5918 16.5855 14.1224 19.1336C13.653 16.5855 11.6593 14.5918 9.11133 14.1224C11.6593 13.653 13.653 11.6593 14.1224 9.11133Z"
          fill="#383838"
        />
        <path
          d="M14.1224 9.11133C14.5918 11.6593 16.5855 13.653 19.1336 14.1224C16.5855 14.5918 14.5918 16.5855 14.1224 19.1336C13.653 16.5855 11.6593 14.5918 9.11133 14.1224C11.6593 13.653 13.653 11.6593 14.1224 9.11133Z"
          fill="white"
        />
      </Icon>
    );
  }

  return (
    <Icon
      {...props}
      viewBox="0 0 28 28"
    >
      <rect
        x="1.81934"
        y="1.82227"
        width="24.6081"
        height="24.6081"
        rx="12.3041"
        fill="#B9DDFF"
      />
      <path
        d="M20.0417 7.45933L11.3579 10.0738C10.7724 10.2501 10.3143 10.7082 10.138 11.2937L7.5235 19.9775C7.39781 20.395 7.7873 20.7845 8.20478 20.6588L16.8886 18.0443C17.4741 17.868 17.9322 17.4099 18.1085 16.8244L20.723 8.14061C20.8487 7.72313 20.4592 7.33363 20.0417 7.45933Z"
        fill="white"
      />
    </Icon>
  );
};
